import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { ActionBar, Button } from '../ui';

const NavigationButtons = ({ 
  onNext, 
  nextLabel = 'Continuar', 
  disableNext = false, 
  isLoading = false,
  onBack = null,
  backLabel = 'Volver',
  primaryButtonId = undefined
}) => {
  const [isButtonProcessing, setIsButtonProcessing] = useState(false);

  const handleNextClick = async (e) => {
    // Prevenir múltiples clics en el botón
    if (isButtonProcessing || isLoading) {
      e.preventDefault();
      return;
    }

    setIsButtonProcessing(true);
    
    try {
      if (onNext) {
        await onNext();
      }
    } catch (error) {
      console.error('Error en NavigationButtons:', error);
    } finally {
      setIsButtonProcessing(false);
    }
  };

  return (
    <ActionBar
      secondary={
        onBack ? (
          <Button variant="link" onClick={onBack}>
            <FontAwesomeIcon icon={faArrowLeft} />
            {backLabel}
          </Button>
        ) : null
      }
      primary={
        onNext ? (
          <Button
            id={primaryButtonId}
            variant="primary"
            onClick={handleNextClick}
            disabled={disableNext || isLoading || isButtonProcessing}
          >
            {(isLoading || isButtonProcessing) && (
              <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
            )}
            {nextLabel}
            <FontAwesomeIcon icon={faArrowRight} />
          </Button>
        ) : null
      }
    />
  );
};

export default NavigationButtons;
